// extracted by mini-css-extract-plugin
export var introContainer = "home-intro-module--intro-container--a3163";
export var introContent = "home-intro-module--intro-content--3ab03";
export var introDescription = "home-intro-module--intro-description--3a215";
export var introImage = "home-intro-module--intro-image--76de6";
export var introImageContainer = "home-intro-module--intro-image-container--f0912";
export var introTitle = "home-intro-module--intro-title--e1f23";